import React from 'react'
import glamorous from "glamorous"

const Page5Container = glamorous.div({
  marginTop: "200px",
  textAlign: "center",
  fontSize: "60px"
})

export const Page5 = () => {
  return <Page5Container>Page 5</Page5Container>
}



// WEBPACK FOOTER //
// ./src/components/Page5.js